<template>
  <div :id="page_slug">
    <div class="crumbs-bar">
        <el-row>
            <el-col :span="12">
                <el-breadcrumb separator-class="el-icon-arrow-right">
                <el-breadcrumb-item :to="{ name: 'DashboardPage' }">Dashboard</el-breadcrumb-item>
                <el-breadcrumb-item>Corporations</el-breadcrumb-item>
                </el-breadcrumb>        
            </el-col>      
        </el-row>
    </div>

    <div class="actions-bar">
        <el-row>
            <el-col :span="8">
                <el-input placeholder="Search By Company Name" v-on:keyup.native="whichSearchFunctionToUse" v-model="search_terms">
                   <template slot="append"><el-button slot="append" disabled icon="el-icon-search"></el-button></template>
                </el-input>
            </el-col>

            <el-col :span="14" :offset="2" class="text-right">
                <el-dropdown trigger="click" :hide-on-click="false">
                    <el-tooltip class="item" effect="light" content="Show or hide columns" placement="top">
                    <el-button>
                        Columns <i class="el-icon-caret-bottom"></i>
                    </el-button>
                    </el-tooltip>
                    <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item v-for="(column, index) in columns" :key="index">
                        <el-checkbox v-model="columns[index]">{{index | prettyIndexName}}</el-checkbox>
                    </el-dropdown-item>
                    </el-dropdown-menu>
                </el-dropdown>

                <router-link :to="{ name: 'CorporationAdd' }">
                    <el-button :disabled="!hasRole('corporations.can_add')" type="default">Add Corporation</el-button>
                </router-link>
            </el-col>
        </el-row>
    </div>

    <el-row>
        <el-table
            v-loading="loading"
            :data="corporations"
            border
            resizable="true"
            style="width: 100%">

            <el-table-column
                v-if="columns.id"
                prop="id"
                label="ID"
                width="115%">
            </el-table-column>

            <el-table-column
                v-if="columns.corporateUID"
                prop="corporateUID"
                label="Corporation UID">
            </el-table-column>

            <el-table-column
                v-if="columns.name"
                prop="name"
                label="Name">
            </el-table-column>

            <el-table-column
                v-if="columns.portal_ip"
                prop="portal_ip"
                label="Portal IP">
            </el-table-column>

            <el-table-column
                v-if="columns.portal_url"
                prop="portal_url"
                label="Portal URL">
            </el-table-column>

            <el-table-column
                v-if="columns.backend_portal_url"
                prop="backend_portal_url"
                label="Backend Portal URL">
            </el-table-column>

            <el-table-column
                v-if="columns.notes"
                prop="notes"
                label="Notes">
            </el-table-column>

            <el-table-column
                v-if="columns.hq_fee"
                prop="hq_fee"
                label="Headquarters Fee">
            </el-table-column>

            <el-table-column
                v-if="columns.site_fee"
                prop="site_fee"
                label="Site Fee">
            </el-table-column>

            <el-table-column
                v-if="columns.licence_count"
                prop="licence_count"
                label="Licence Count">
            </el-table-column>

            <el-table-column
                v-if="columns.account_manager_name"
                prop="account_manager_name"
                label="Account Manager">
                <template slot-scope="scope">
                    {{scope.row.account_manager.firstName + ' ' + scope.row.account_manager.lastName}}
                </template>
            </el-table-column>

            <el-table-column
                v-if="columns.created_user_id"
                prop="created_user_id"
                label="Created User ID">
            </el-table-column>

            <el-table-column
                v-if="columns.updated_user_id"
                prop="updated_user_id"
                label="Updated User ID">
            </el-table-column>

            <el-table-column
                v-if="columns.created_at"
                align="center"
                width="115%"
                prop="created_at"
                label="Created Date">
                <template slot-scope="scope">
                {{scope.row.created_at | moment(config.date_format_compact)}}
                </template>          
            </el-table-column>

            <el-table-column
                v-if="columns.updated_at"
                align="center"
                width="115%"
                prop="updated_at"
                label="Updated Date">
                <template slot-scope="scope">
                {{scope.row.updated_at | moment(config.date_format_compact)}}
                </template>          
            </el-table-column>

            <el-table-column
                label="Actions"
                align="center"
                width="115%">
                <template slot-scope="scope">
                    <router-link :to="{ name: 'CorporationEdit', params: { id: scope.row.id }}">
                        <el-button 
                            :disabled="!hasRole('corporations.can_edit')"
                            icon="el-icon-edit"
                            type="default" 
                            size="small">
                        </el-button>
                    </router-link>

                    <el-button 
                        :disabled="!hasRole('corporations.can_delete')"
                        icon="el-icon-delete" 
                        type="default" 
                        size="small"
                        @click="deleteCorporation(scope.row.id)">
                    </el-button>
                </template>
            </el-table-column>
        </el-table>
    </el-row>

    <el-row :gutter="0">
        <el-col :span="24" :xs="24" :sm="24" class="pagination">
            <el-pagination
                background
                @current-change="handleCurrentChange"
                :current-page.sync="pagination.current_page"
                :page-count="pagination.total_pages"
                :page-size="pagination.per_page"
                layout="total, prev, pager, next"
                :total="pagination.total">
            </el-pagination>
        </el-col>
    </el-row>

      <pre>{{$data}}</pre>
  </div>
</template>

<style>

</style>

<script>
  import Config from '@/store/Config.js';
  import Tables from '@/store/Tables.js';
  import store from '@/store/Store.js';

    export default {
        data: function() {
            return {
                page_alias: 'Corporation List',
                page_slug: 'coporation-list',

                permissions: store.permissions,
                config: Config.config,
                columns: Tables.corporations.columns,
                order_by: Tables.corporations.order_by,
                sort_by: Tables.corporations.sort_by,

                loading: true,
                corporations: [],
                search_terms: '',

                pagination: {
                    total: 0,
                    per_page: 0,
                    current_page: 0,
                    last_page: 0,
                    next_page_url: '',
                    prev_page_url: '',
                    from: 0,
                    to: 0,
                },
            };
        },
            
        mounted: function() {
            const me = this;
            me.getCorporations();
        },

        methods: {
            hasRole: function(role_name) {
            const me = this;

            if(me.permissions.user_roles.length > 0) {
            /* returns undefined if doesn't find the role */
            var role = _.find(me.permissions.user_roles, function(o) { 
                return o.name == role_name; 
            });

            /* doesn't enter if when undefined */
            if(role) {
                return true
            }
            }
            
            return false;
        },

            whichSearchFunctionToUse: function() {
                const me = this;

                if(me.search_terms == '') {
                    me.getCorporations();
                } else me.search();
            },

            search: function(goToPage) {
                console.log('Search Corporations Function');
                const me = this;
                me.loading = true;
                me.$http.get(me.config.api + 'search-corporation', {params: {search_query: me.search_terms, page: goToPage}}).then(
                    response => {
                    console.log('Success Getting Data')  
                    console.log(response.status);
                    console.log(response.statusText);
                    me.corporations = response.body.data;
                    me.pagination.total = response.body.total;
                    me.pagination.per_page = response.body.per_page;
                    me.pagination.current_page = response.body.current_page;
                    me.pagination.last_page = response.body.last_page;
                    me.pagination.next_page_url = response.body.next_page_url;
                    me.pagination.prev_page_url = response.body.prev_page_url;
                    me.pagination.from = response.body.from;
                    me.pagination.to = response.body.to;
                    me.loading = false;
                }, response => {
                    console.log('Error Getting Data');
                    console.log(response.status);
                    console.log(response.statusText);
                    me.$notify({
                        title: 'Error',
                        message: response.statusText,
                        type: 'error'
                    });
                    me.loading = false;
                });
            },

            getCorporations: function(goToPage) {
                console.log('Get Corporations Function');
                const me = this;
                me.loading = true;
                me.$http.get(me.config.api + 'corporation', {params: {backend_call: 1, page: goToPage}}).then(
                    response => {
                    console.log('Success Getting Data')  
                    console.log(response.status);
                    console.log(response.statusText);
                    me.corporations = response.body.data;
                    me.pagination.total = response.body.total;
                    me.pagination.per_page = response.body.per_page;
                    me.pagination.current_page = response.body.current_page;
                    me.pagination.last_page = response.body.last_page;
                    me.pagination.next_page_url = response.body.next_page_url;
                    me.pagination.prev_page_url = response.body.prev_page_url;
                    me.pagination.from = response.body.from;
                    me.pagination.to = response.body.to;
                    me.loading = false;
                }, response => {
                    console.log('Error Getting Data');
                    console.log(response.status);
                    console.log(response.statusText);
                    me.$notify({
                        title: 'Error',
                        message: response.statusText,
                        type: 'error'
                    });
                    me.loading = false;
                });
            },

            // Pagination request
            handleCurrentChange(val) {
                const me = this;

                if(me.search_terms == '') {
                    me.getCorporations(val);
                } else {
                    me.search(val);
                }

                window.scrollTo(0,0);
            },
            
            deleteCorporation: function(id) {
                console.log('delete corporation function');
                const me = this;
                me.$confirm('This will permanently delete the corporation - Continue?', 'Warning', {
                    confirmButtonText: 'OK',
                    cancelButtonText: 'Cancel',
                    type: 'warning'
                }).then(() => {
                me.$http.delete(me.config.api + 'corporation/{id}', {params: {id : id}}).then(
                    response => {
                        console.log('Success Deleting Data')  
                        console.log(response.status);
                        console.log(response.statusText);
                        me.getCorporations();
                        me.$notify({
                            title: 'Success',
                            message: 'The Corporation Was Deleted',
                            type: 'success',
                        });
                    }, response => {
                        console.log('Error Getting Data');
                        console.log(response.status);
                        console.log(response.statusText);
                    });  
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: 'Delete Canceled'
                    });          
                });
            }
        },

        filters: {
            prettyIndexName(text) {
                var prettyName = text.replace(/_/g, ' ').toUpperCase();
                return prettyName
            }
        }  
    }
</script>





// WEBPACK FOOTER //
// src/pages/corporations/CorporationList.vue